export const SET_REGULATION_TYPE = "SET_REGULATION_TYPE";
